"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DisbursementInvoices {
}
exports.DisbursementInvoices = DisbursementInvoices;
//# sourceMappingURL=DisbursementInvoices.js.map